import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { SortOrder, listFiltersService, ListTableSort } from "sprint-common-web";

export interface IntegratorListingFilters {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: SortOrder;
    name?: string;
}

const defaultFilters: IntegratorListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "asc",
    name: ""
};

export const useIntegratorListingFilters = () => {
    const filtersService = useMemo(() => listFiltersService<IntegratorListingFilters>(defaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<IntegratorListingFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setSort = (sort: ListTableSort) => {
        setFilters((prevFilters: IntegratorListingFilters) => ({
            ...prevFilters,
            sortBy: sort.by,
            sortOrder: sort.order,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: IntegratorListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: IntegratorListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name?: string): void => {
        setFilters((prevFilters: IntegratorListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setName,
        setPage,
        setPageSize,
        setSort,
        clearFilters
    };
};
